import { render } from "./GanttListTask.vue?vue&type=template&id=2c7f37a1"
import script from "./GanttListTask.vue?vue&type=script&lang=ts"
export * from "./GanttListTask.vue?vue&type=script&lang=ts"
script.render = render

export default script